import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logo from './logo-full.svg';
import './KawasakiSmallLogo.css';
import { useIwaContext } from '@cognitranlimited/itis-web';
export var KawasakiSmallLogo = function () {
    var strings = useIwaContext().strings;
    return _jsx("img", { className: "KawasakiSmallLogo", src: logo, alt: strings.app.name });
};
